import MobileDrawer from '@c/drawers/MobileDrawer';
import { sortingOptions } from '@c/ProductsPage';
import { PageSideFilters } from '@util/hooks/useProductsPage';
import { CheckIcon } from 'lucide-react';
import { ProductSortOption } from 'models/product';

type SortingOption = {
  label: string;
  value: ProductSortOption;
  id: string;
  icon: JSX.Element;
};

type MobileSearchSortProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  sortingBy: string;
  onSortingChange: (sortingBy: SortingOption) => void;
  pageType?: string;
  filterState: PageSideFilters;
};

export default function MobileSearchSort({
  show,
  setShow,
  sortingBy,
  onSortingChange,
  pageType,
  filterState,
}: MobileSearchSortProps) {
  return (
    <MobileDrawer show={show} title="Sort" dismiss={() => setShow(false)}>
      <div>
        {sortingOptions
          .filter((option) => {
            if (pageType === 'profile') {
              return option.id !== 'soldDate';
            } else if (pageType === 'recent') {
              return option.id !== 'bestMatch';
            } else if (!filterState.recentlySold) {
              return option.id !== 'soldDate';
            }
            return true;
          })
          .map((option) => (
            <button
              key={option.value}
              className={`flex w-full items-center justify-between p-6 ${
                sortingBy === option.value ? 'bg-[#F1F1F1] text-zinc-700' : ''
              }`}
              onClick={() => {
                onSortingChange(option);
                setShow(false);
              }}
            >
              <span className="text-[2.1rem] font-medium text-black">
                {option.label}
              </span>

              {sortingBy === option.value && (
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-secondary p-2">
                  <CheckIcon className="h-full w-full text-white" />
                </div>
              )}
            </button>
          ))}
      </div>
    </MobileDrawer>
  );
}
